import React from 'react';
import {Glob as G} from "../../libs/Glob.mjs";
import {Button, ButtonGroup, Input} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import TrashIcon from "../../media/images/TrashIcon.mjs";
import ChevronUpIcon from "../../media/images/ChevronUpIcon.mjs";
import ChevronDownIcon from "../../media/images/ChevronDownIcon.mjs";
import EditIcon from "../../media/images/EditIcon.mjs";
import CheckIcon from "../../media/images/CheckIcon.mjs";

const EditorSubUnits = class extends React.Component {
	constructor(props) {
		super(props);
		let units = props.units || [];
		if (!Array.isArray(units)) units = [units];
		units = units.map(u => {
			if (typeof u === 'string') u = {label: u, value: u};
			return u;
		});
		this.state = {
			orig: units,
			units: units.length ? G.clone(units) : []
		}
		this.uid = G.generateUid('units');
		this.swap = this.swap.bind(this);
	}

	swap(from, to) {
		const o = this.state.units;
		const a = G.clone(o[from]);
		const b = G.clone(o[to]);
		o[from] = b;
		o[to] = a;
		this.setState({
			units: o,
			addValue: undefined,
			addLabel: undefined,
			addIcon: undefined,
			addMulti: undefined
		}, () => {
			this.props.setValue(o);
		});
	}

	render() {
		return (
			<table className={"SubfieldOptions"}>
				<thead>
				<tr>
					<th style={{width: "80px", textAlign: "center"}}>
						<TextLabel value={"Value"}/>
					</th>
					<th style={{padding: "0 16px"}}>
						<TextLabel value={"Label"}/>
					</th>
					<th style={{padding: "0 16px", textAlign: "center"}}>
						<TextLabel value={"Multiplier"}/>
					</th>
					<th/>
				</tr>
				</thead>
				<tbody>
				{this.state.units.map((unit, idx) => (
					<tr key={idx}>
						<td align={"center"}>{unit.value}</td>
						<td style={{padding: "0 16px"}}>{unit.label}</td>
						<td style={{padding: "0 16px", textAlign: "end"}}>{unit.multi}</td>
						<td>
							<ButtonGroup className={"btn-icon"}>
								<Button
									color="link"
									onClick={() => {
										this.setState({
											addValue: unit.value,
											addLabel: unit.label,
											addMulti: unit.multi,
											addIndex: idx
										})
									}}
								>
									<EditIcon/>
								</Button>
								<Button
									color={"link"}
									onClick={() => {
										if (window.confirm(`Confermi l’eliminazione di “${unit.label}?”`)) {
											const o = this.state.units;
											o.splice(idx, 1);
											this.setState({options: o}, () => {
												this.props.setValue(o);
											});
										}
									}}
								>
									<TrashIcon/>
								</Button>
								<Button
									disabled={idx === 0}
									color="link"
									onClick={() => {
										this.swap(idx, idx - 1)
									}}
								>
									<ChevronUpIcon/>
								</Button>
								<Button
									disabled={idx >= (this.state.units.length - 1)}
									color="link"
									onClick={() => {
										this.swap(idx, idx + 1)
									}}
								>
									<ChevronDownIcon/>
								</Button>
							</ButtonGroup>
						</td>
					</tr>
				))}
				<tr>
					<td>
						<Input
							style={{textAlign: "center"}}
							type={"text"}
							value={this.state.addValue || ''}
							onChange={(e) => {
								this.setState({addValue: e.target.value});
							}}
						/>
					</td>
					<td>
						<Input
							type={"text"}
							value={this.state.addLabel || ''}
							onChange={event => {
								this.setState({addLabel: event.target.value});
							}}
						/>
					</td>
					<td>
						<Input
							type={"number"}
							style={{ maxWidth: "140px"}}
							value={this.state.addMulti || 1 }
							onChange={event => {
								const v = parseFloat( event.target.value || 1);
								this.setState({addMulti: v === 1 ? undefined : v });
							}}
						/>
					</td>
					<td align={"center"}>
						<ButtonGroup>
							<Button
								color={"warning"}
								onClick={() => {
									this.setState({addValue: '', addLabel: '', addIndex: undefined})
								}}
							>
								<TextLabel value={"close"} lang={"icon"}/>
							</Button>
							<Button
								className={"btn-icon"}
								disabled={!this.state.addLabel}
								color={this.state.addLabel ? 'success' : 'secondary'}
								onClick={() => {
									const o = this.state.units;
									const obj = {
										label: this.state.addLabel,
										value: this.state.addValue
									};
									if ( typeof this.state.addMulti !== 'undefined') obj.multi = this.state.addMulti;
									if ( obj.multi === 1) delete obj.multi;
									if (typeof this.state.addIndex === 'number') {
										o[this.state.addIndex] = obj;
									} else {
										o.push(obj);
									}
									this.setState({units: G.clone(o), addValue: '', addLabel: '', addIndex: undefined, addMulti: undefined}, () => {
										this.props.setValue(o);
									});
								}}
							>
								{typeof this.state.addIndex === 'number' ? <EditIcon/> : <CheckIcon/>}
							</Button>
						</ButtonGroup>
					</td>
				</tr>
				</tbody>
			</table>
		)
	}
}

export default EditorSubUnits;
